import { ROUTES } from '@/app/lib/constants'
import { CoursesPage } from '@/app/modules/course/pages'
import { isBoom } from '@hapi/boom'

export async function getStaticProps(context) {
  const { locale } = context

  try {
    return {
      props: {
        messages: {
          ...(await import(`@/locales/${context.locale}/navigation.json`))
            .default,
          ...(await import(`@/locales/${context.locale}/common.json`)).default,
          ...(await import(`@/locales/${context.locale}/shared-components.json`))
            .default,
          ...(await import(`@/locales/${context.locale}/courses-listing.json`))
            .default,
        },
      },
    }
  } catch (e) {
    console.error(e)
    if (isBoom(e, 401)) {
      return {
        redirect: {
          destination: ROUTES.logout,
          permanent: false,
          locale,
        },
      }
    } else if (isBoom(e, 403)) {
      return {
        redirect: {
          destination: `/${locale}${ROUTES.accessDenied}`,
          permanent: false,
          locale,
        },
      }
    }

    throw e
  }
}

export default CoursesPage
